<template>
  <div id="wv_weekly_insights">
    <div class="header">
      <div class="box flex-mid">
        <img
          class="icon-card mr-16 cursor-pointer"
          @click="goBackDay()"
          :src="$utils('icons', 'navigate_before_white_32px')"
          alt=""
        />
        <el-date-picker
          v-model="dateInput"
          type="date"
          format="ddd, MMMM d, yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Pick a day"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <img
          @click="goNextDay()"
          class="icon-card ml-16 cursor-pointer"
          :src="$utils('icons', 'navigate_after_white_32px')"
          alt=""
        />
      </div>
    </div>
    <template v-if="inforWeeklyData && inforWeeklyData.preview">
      <div v-html="inforWeeklyData.preview" style="margin-top: -4px;"></div>
    </template>
    <div v-else class="center fc-A0A0A0 fs-24 mt-32" style="margin-top: -4px;">
      <div v-if="!dateInput" style="padding-top: 80px">
        <div class="fs-16 fw-700 fc-000000 opa-04">
          Preview a report by selecting a date <br />
          from the above menu
        </div>
      </div>
      <div v-else-if="loadingWeeklyReportStatus" style="padding-top: 80px">
        <i class="el-icon-loading"></i>
        <div class="fs-16">Loading...</div>
      </div>
      <div
        style="padding-top: 80px"
        v-else-if="!loadingWeeklyReportStatus && !inforWeeklyData.preview"
      >
        <div class="fs-16">
          Unable to preview this report due to unavailability of sufficient data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
export default {
  name: "weekly-insights",
  data() {
    return {
      themeMode: "light",
      email:'',
      dateInput: "",
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() - 86400000 ||
            time.getDay() == 0 ||
            time.getDay() == 6 ||
            time.getDay() == 5 ||
            time.getDay() == 4 ||
            time.getDay() == 3 ||
            time.getDay() == 2
          );
        },
      },
    };
  },
  watch: {
    dateInput() {
      this.getDataReport()
    },
  },
  computed: {
    backgroundColor() {
      switch (this.themeMode) {
        case "light":
          return "light";
        case "dark":
          return "dark";
        default:
          return "light";
      }
    },
    inforWeeklyData() {
      return this.$store.getters["report/inforWeeklyData"];
    },
    loadingWeeklyReportStatus() {
      return this.$store.getters["report/loadingWeeklyReportStatus"];
    },
  },
  mounted() {
    if(this.$route.params.id){
        let bytes = CryptoJS.AES.decrypt(
        this.$route.params.id,
          "HappilyWeekly"
        );
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (originalText) {
          let codeSplit = originalText.split("||");
          this.email = codeSplit[0].replace(/\|\|/g, '.');
          this.dateInput = codeSplit[1];
          this.getDataReport();
        }
      }
    
  },
  methods: {
    getDataReport(){
      if(this.email && this.dateInput)
      this.$store.dispatch("report/getDataPreview", {
        user: this.email,
        date:this.dateInput,
        type: "report_weekly_boss",
        loading: "Weekly",
      }).then(()=>{
        this.firstTimeloading = false;
      });
    },
    goBackDay() {
      // console.log("goBackDay", this.dateInput) // TODO : goBackDay function.
        if (this.dateInput) {
          let beforeThisDay = this.dateInput
          // if(format(addDays(beforeThisDay,-1),"YYYY-MM-DD") > format(new Date("2021-08-31"),"YYYY-MM-DD")){
            do{
              beforeThisDay = format(addDays(beforeThisDay,-1),"YYYY-MM-DD")
            }
            while(new Date(beforeThisDay).getDay() == 0 || new Date(beforeThisDay).getDay() == 6 || new Date(beforeThisDay).getDay() == 5 || new Date(beforeThisDay).getDay() == 4 || new Date(beforeThisDay).getDay() == 3 || new Date(beforeThisDay).getDay() == 2)
            this.dateInput = beforeThisDay;
          // }
        } else {
          this.dateInput = format(new Date(),"YYYY-MM-DD")
        }
    },
    goNextDay() {
      // console.log("goNextDay", this.dateInput) // TODO : goNextDay function.
      if (this.dateInput) {
        let nextDay = this.dateInput
        if(format(addDays(nextDay,1),"YYYY-MM-DD") <= format(new Date(),"YYYY-MM-DD")){
          do{
            nextDay = format(addDays(nextDay,1),"YYYY-MM-DD")
          }
          while(new Date(nextDay).getDay() == 0 || new Date(nextDay).getDay() == 6 || new Date(nextDay).getDay() == 5 || new Date(nextDay).getDay() == 4 || new Date(nextDay).getDay() == 3 || new Date(nextDay).getDay() == 2)
          this.dateInput = nextDay;
        }
      } else {
        this.dateInput = format(new Date(),"YYYY-MM-DD")
      }
    },
  }
};
</script>

<style lang="scss" scoped>
// .light, .dark {
//   min-height: 400px;
// }
// .light {
//   background-color: #fff;
// }
// .dark {
//   background-color: #242424;
// }
.header {
  height: calc(80px - 32px);
  background: #6d27bf;
  padding: 16px;
  .box {
    color: #fff;
  }
}
</style>

<style lang="scss">
#wv_weekly_insights {
  input,
  .el-input--prefix .el-input__inner,
  .el-input__inner {
    border: 1px solid rgba($color: #000000, $alpha: 0.2);
    background-color: rgba($color: #000000, $alpha: 0.2);
    color: #fff;
    height: 48px;
  }
}
</style>